module.exports = __webpack_public_path__ + "static/media/moraine-7.07fa9c70.jpg";